module.exports = __webpack_public_path__ + "img/2025_VolunteerShirt.f6f8962b.jpg";